import PropTypes from 'prop-types';

export const currentUserType = PropTypes.shape({
  id: PropTypes.string.isRequired,
  analyticsId: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  firstName: PropTypes.string.isRequired,
  lastName: PropTypes.string.isRequired,
  email: PropTypes.string.isRequired
});

export const currentProjectEntitlementsType = PropTypes.shape({
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  accountId: PropTypes.string.isRequired,
  accountName: PropTypes.string.isRequired,
  projectScope: PropTypes.arrayOf(PropTypes.string).isRequired,
  containers: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      type: PropTypes.string.isRequired
    })
  ).isRequired
});
